import React from "react";
import Firebase from "../../constants/Firebase";
// import "./form.css";

class addLinkForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			url: "",
			name: "",
			description: "",
			editLabel: "",
			correctLength: true,
		};
		this.input = React.createRef();
		this.handleChangeName = this.handleChangeName.bind(this);
		this.handleChangeDescription = this.handleChangeDescription.bind(this);
		this.handleChangeURL = this.handleChangeURL.bind(this);
		this.handleChangeEditLabel = this.handleChangeEditLabel.bind(this);
		// this.removeStartString = this.removeStartString.bind(this);
		// this.removeEndString = this.removeEndString.bind(this);
		this.submitLink = this.submitLink.bind(this);
		this.submitEditLabel = this.submitEditLabel.bind(this);
		this.postLinkFirebase = this.postLinkFirebase.bind(this);
		this.postEditLabelFirebase = this.postEditLabelFirebase.bind(this);
		this.deleteLabel = this.deleteLabel.bind(this);
	}

	// FOCUS IN MODAL
	componentDidMount() {
		this.input.focus();
	}

	// URL (+ NAME) SET STATE
	handleChangeURL(event) {
		const stringWithoutStart = this.removeStartString(event);
		const stringWithoutEnd = this.removeEndString(stringWithoutStart);
		this.setState({ url: event.target.value, name: stringWithoutEnd });
	}

	// NAME SET STATE
	handleChangeName(event) {
		this.setState({ name: event.target.value });
	}

	// DESCRIPTION SET STATE
	handleChangeDescription(event) {
		this.setState({ description: event.target.value });
	}

	// DESCRIPTION SET STATE
	handleChangeEditLabel(event) {
		this.setState({ editLabel: event.target.value.toUpperCase() });
	}

	// REMOVE NAME STRING START
	removeStartString(event) {
		// NAME SET STATE MODIFY STRING
		const nameStringToTransform = event.target.value;
		let transformedNameString = "";
		if (nameStringToTransform.startsWith("http://")) {
			transformedNameString = nameStringToTransform.replace("http://", "");
		}
		if (nameStringToTransform.startsWith("https://")) {
			transformedNameString = nameStringToTransform.replace("https://", "");
		}
		if (nameStringToTransform.startsWith("http://www.")) {
			transformedNameString = nameStringToTransform.replace("http://www.", "");
		}
		if (nameStringToTransform.startsWith("https://www.")) {
			transformedNameString = nameStringToTransform.replace("https://www.", "");
		} else {
			// CORRECT LENGTH MESSAGE APPEARS
			this.setState({
				correctLength: false,
			});
		}
		return transformedNameString;
	}

	// REMOVE NAME STRING END
	removeEndString(stringWithoutStart) {
		let transformedNameString = "";
		if (stringWithoutStart.endsWith("/")) {
			transformedNameString = stringWithoutStart.substring(
				0,
				stringWithoutStart.length - 1
			);
		}
		if (stringWithoutStart.length > 25) {
			transformedNameString = stringWithoutStart.substring(0, 25);
		} else {
			// CORRECT LENGTH MESSAGE APPEARS
			this.setState({
				correctLength: false,
			});
		}
		return transformedNameString;
	}

	// SUBMIT LINK
	submitLink(e) {
		e.preventDefault();

		// CORRECT LENGTH CHECK
		if (
			this.state.name.length >= 1 &&
			this.state.name.length <= 25 &&
			this.state.url.length >= 1 &&
			this.state.url.length <= 2048 &&
			this.state.description.length <= 2048
		) {
			// POST TO FIREBASE FUNCTION
			this.postLinkFirebase();
		} else {
			// CORRECT LENGTH MESSAGE APPEARS
			this.setState({
				correctLength: false,
			});
		}
	}

	// SUBMIT EDIT LABEL
	submitEditLabel(e) {
		e.preventDefault();

		// CORRECT LENGTH CHECK
		if (this.state.editLabel.length >= 1 && this.state.editLabel.length <= 25) {
			// POST TO FIREBASE FUNCTION
			this.postEditLabelFirebase();
		} else {
			// CORRECT LENGTH MESSAGE APPEARS
			this.setState({
				correctLength: false,
			});
		}
	}

	// POST EDIT LABEL TO FIREBASE
	async postEditLabelFirebase() {
		// DESCRIPTION OR URL
		const requestOptions = {
			method: "PATCH",
			redirect: "follow",
			headers: {
				"Content-Type": "application/json",
			},

			// CONVERT STATE IN JSON STRING
			body: JSON.stringify({
				title: this.state.editLabel,
			}),
		};

		await fetch(
			`${Firebase.databaseURL}/users/${this.props.user.localId}/tabs/${this.props.tabID}/categories/${this.props.catID}/labels/${this.props.labelID}.json?auth=${this.props.user.idToken}`,
			requestOptions
		)
			// .then((response) => response.json())
			.then((result) => {
				// CLOSE MODAL AFTER POST
				this.props.closeModal();
			})
			.catch((error) => console.log("error:", error));

		// FETCH AFTER POST TO REFRESH CONTENT
		this.props.fetchFirebase();
	}

	// POST LINK TO FIREBASE
	async postLinkFirebase() {
		// DESCRIPTION OR URL
		const requestOptions = {
			method: "POST",
			redirect: "follow",
			headers: {
				"Content-Type": "application/json",
			},

			// CONVERT STATE IN JSON STRING
			body: JSON.stringify({
				url: this.state.url,
				name: this.state.name,
				description: this.state.description,
			}),
		};

		await fetch(
			`${Firebase.databaseURL}/users/${this.props.user.localId}/tabs/${this.props.tabID}/categories/${this.props.catID}/labels/${this.props.labelID}/links.json?auth=${this.props.user.idToken}`,
			requestOptions
		)
			// .then((response) => response.json())
			.then((result) => {
				// CLOSE MODAL AFTER POST
				this.props.closeModal();
			})
			.catch((error) => console.log("error:", error));

		// FETCH AFTER POST TO REFRESH CONTENT
		this.props.fetchFirebase();
	}

	// FETCH DELETE LABEL
	async deleteLabel() {
		const requestOptions = {
			method: "DELETE",
			redirect: "follow",
		};

		await fetch(
			`${Firebase.databaseURL}/users/${this.props.user.localId}/tabs/${this.props.tabID}/categories/${this.props.catID}/labels/${this.props.labelID}.json?auth=${this.props.user.idToken}`,
			requestOptions
		)
			// PARSE JSON HTTP RESPONSE TO TRANSFORM INTO JS OBJECT
			.then((response) => response.json())
			.then((result) => {
				// console.log(result);
			})
			.catch((error) => console.log("error:", error));
		// FETCH AFTER DELETE TO REFRESH CONTENT
		this.props.fetchFirebase();
	}

	render() {
		return (
			<div className="form-wrapper-margin">
				<div className="form-outer-wrapper">
					{/* LINK FORM LEGEND */}
					<legend className="form-legend">Add Link to</legend>

					<form className="form-div" action="#">
						{/* LINK NAME INPUT */}
						<input
							required
							className="form-input-tab"
							type="text"
							name="link-item"
							id="link-item"
							placeholder={this.props.labTitle}
							value={this.state.editLabel}
							onChange={this.handleChangeEditLabel}
						/>

						{/* SUBMIT BUTTON */}
						<button className="edit-button" onClick={this.submitEditLabel}>
							Edit
						</button>
					</form>

					{/* DELETE LABEL BUTTON*/}
					<button
						className="delete-tab-button"
						onClick={(e) => {
							if (window.confirm("Are you sure you wish to delete this item?"))
								this.deleteLabel(e);
						}}
					>
						Delete
					</button>
				</div>

				<form className="form-div-column" action="#">
					{/* LINK URL LABEL */}
					<label className="form-label" htmlFor="link-item">
						URL Link
					</label>

					{/* LINK URL INPUT */}
					<input
						required
						className="form-input"
						type="text"
						name="link-item"
						id="link-item"
						placeholder="https://bkz-src.com/"
						value={this.state.url}
						onChange={this.handleChangeURL}
						ref={(inputFocus) => {
							this.input = inputFocus;
						}}
					/>

					{/* CORRECT LENGTH CHECK MESSAGE */}
					{this.state.correctLength ? null : (
						<div className="div-correct-length">
							<p className="p-correct-length">
								URL length can be between 1 and 2048 characters and starts with:
								"http://", "https://", "http://www.", or "https://www.".
							</p>
						</div>
					)}

					{/* LINK NAME LABEL */}
					<label className="form-label" htmlFor="link-item">
						Name
					</label>

					{/* LINK NAME INPUT */}
					<input
						required
						className="form-input"
						type="text"
						name="link-item"
						id="link-item"
						placeholder="bkz-src.com"
						value={this.state.name}
						onChange={this.handleChangeName}
					/>

					{/* CORRECT LENGTH CHECK MESSAGE */}
					{this.state.correctLength ? null : (
						<div className="div-correct-length">
							<p className="p-correct-length">
								Name length can be between 1 and 25 characters.
							</p>
						</div>
					)}

					{/* LINK DESCRIPTION LABEL */}
					<label className="form-label" htmlFor="link-item">
						Description
					</label>

					<p className="desc-p">(Optional)</p>

					{/* LINK DESCRIPTION INPUT */}
					<input
						className="form-input"
						type="text"
						name="link-item"
						id="link-item"
						placeholder="bkz-src"
						value={this.state.description}
						onChange={this.handleChangeDescription}
					/>

					{/* CORRECT LENGTH CHECK MESSAGE */}
					{this.state.correctLength ? null : (
						<div className="div-correct-length">
							<p className="p-correct-length">
								Description length can be under 2048 characters.
							</p>
						</div>
					)}

					{/* SUBMIT BUTTON */}
					<button className="submit-button" onClick={this.submitLink}>
						Submit
					</button>
				</form>
			</div>
		);
	}
}

export default addLinkForm;
